import { I18n, Translate2 as Translate } from 'common'
import { CartProduct, ICartErrorProduct, IVehiclePriceChangedParts } from 'cart'
import { ReactElement } from 'react'
import { Vehicle } from '../../../../../store/models/Vehicles'
import { defaultTheme } from '../../../../../theme'
import { Price } from '../../../../../ui-components'
import { Hyperlink } from '../../../../../ui-components/util/Hyperlink'
import styled from 'styled-components'
import { Link } from '../../../../../ui-components/util/Interfaces'
import { MessageInfo } from './interfaces'
import { Message } from './Message'
import { MessageItemList } from './MessageItemList'

export interface PriceChangeMsgProps {
  vehicle: Vehicle
  products: Array<ICartErrorProduct>
  buildProductLink?: (p: CartProduct) => Link
  hideLink?: boolean
  removeItemFromCart: (item: IVehiclePriceChangedParts) => void
  noMargin?: boolean
}

export const PriceChangeMsg = (props: PriceChangeMsgProps): ReactElement => {
  const {
    products,
    buildProductLink,
    hideLink,
    removeItemFromCart,
    vehicle,
    noMargin,
  } = props
  const buildPriceChangeMsg = (
    cartErrorProduct: ICartErrorProduct,
    oldPrice: string,
    newPrice: string
  ): MessageInfo => {
    const msgStr = Translate('hasChangedFrom')

    const msg = (
      <span>
        <I18n name={msgStr} />
        <StyledPrice>
          <Price num={Number(oldPrice)} />
        </StyledPrice>
        {` ${Translate('to')} `}
        <StyledPrice style={{ marginRight: '10px' }}>
          <Price num={Number(newPrice)} />
        </StyledPrice>
        <Hyperlink
          action={() => {
            // TODO
            removeItemFromCart({ vehicle, parts: [cartErrorProduct] })
          }}
          color={hideLink ? defaultTheme.colors.link : defaultTheme.colors.red}
        >
          <I18n name={hideLink ? 'removeItemFromOrder' : 'removeItem'} />
        </Hyperlink>
      </span>
    )
    return {
      link: buildProductLink(cartErrorProduct.product),
      message: msg,
    }
  }

  const priceChangedMsgs: MessageInfo[] = []

  const count = products.length

  products.forEach((cartErrorProduct) =>
    cartErrorProduct.product.errors?.forEach((availabilityError) =>
      availabilityError.fieldUpdates?.forEach((update) =>
        priceChangedMsgs.push(
          buildPriceChangeMsg(
            cartErrorProduct,
            update.oldValue,
            update.newValue
          )
        )
      )
    )
  )

  const boldText =
    count > 1
      ? Translate('itemsInYourCartHaveChangedPrice', [count])
      : Translate('itemInYourCartHasChangedPrice')
  const normalText = ''

  return (
    <Message boldText={boldText} normalText={normalText} noMargin={noMargin}>
      <MessageItemList items={priceChangedMsgs} hideLink={hideLink} />
    </Message>
  )
}

const StyledPrice = styled.span`
  color: ${defaultTheme.colors.red};
  font-size: 14px;
  font-weight: bold;
`
